import { axiosService } from 'services';
import { AXIOS_URLS } from 'config';
import { FleetList, CreateFleetListRequest, UpdateFleetListRequest } from '../interfaces/fleetList';

export const fleetListService = {
  getAll: (): Promise<FleetList[]> =>
    axiosService.get(`${AXIOS_URLS.fleet_list}/`).then((res) => res.data),
  getById: (id: number): Promise<FleetList> =>
    axiosService
      .get(`${AXIOS_URLS.fleet_list}/${id}`)
      .then((res) => res.data),
  create: (data: CreateFleetListRequest): Promise<FleetList> =>
    axiosService
      .post(`${AXIOS_URLS.fleet_list}/`, data)
      .then((res) => res.data),
  update: (id: number, data: UpdateFleetListRequest): Promise<FleetList> =>
    axiosService
      .put(`${AXIOS_URLS.fleet_list}/${id}`, data)
      .then((res) => res.data),
  delete: (id: number): Promise<void> =>
    axiosService
      .delete(`${AXIOS_URLS.fleet_list}/${id}`)
      .then((res) => res.data),
};
